<template lang="html">
  <article class="minimal-product-card-container">
    <router-link class="neutral" :to="{ name: 'publication', params: {id: details.id, title: slugify(details.title)} }">
      <div class="minimal-product-card mx-auto">
        <figure class="minimal-product-card-image">
          <span class="minimal-product-card-image-align-helper"></span>
          <div
            class="category-item-image card-img-top my-0"
            :style="`height: 100%; width: 100%; background-image: url(${ imageWithExtensionSmall(image) || noPhoto });`" >
          </div>
        </figure>
        <section class="minimal-product-card-content my-auto">
          <div class="minimal-product-card-title">
            <h5 class="minimal-product-card-title">
              {{ details.title | capitalize }}
            </h5>
          </div>
        </section>
      </div>
    </router-link>
  </article>
</template>

<script>
import CardImpl from './CardImpl'
import { imageWithExtensionSmall } from '@/helpers'
import { slugify } from 'transliteration'

export default (x => x.default || x)({
  ...CardImpl,

  methods: {
    imageWithExtensionSmall,

    slugify
  }
})
</script>

<style lang="scss">
@import "../../scss/aspect";
@import "../../scss/colors";
@import "../../scss/breakpoints";
@import "../../scss/fonts";

$card-aspect: 4.42;
$card-max-height: calc((#{$max-width} / 2) / #{$card-aspect});
$card-image-aspect: 1.46;
$card-image-width: calc(#{$card-max-height} * #{$card-image-aspect});

.minimal-product-card-container {
  position: relative;
  max-height: $card-max-height;
  min-height: $card-max-height;
}

.minimal-product-card {
  display: flex;
  font-size: 0.9rem;
  margin-bottom: 10px;
  // height: 20%;
  overflow: hidden;
  min-height: $card-max-height;
  // height: fit-content;
  width: 98%;
  max-height: $card-max-height;
  //box-shadow: 0.01px 2px 2px $gray-400 !important;
}

.minimal-product-card p {
  margin: 0;
  padding: 0;
}

.minimal-product-card-image {
  margin: 0;
  background-color: $gray-300;
  text-align: center;
  width: 100%;
  max-width: $card-image-width;

  img {
    margin:0 auto;
    vertical-align: middle;
    display:inline-block;
    width: 100%;
  }

}

.minimal-product-card-image-align-helper {
    display: inline-block;
    height: 100%;
    visibility: hidden;
    position:absolute;
    vertical-align: middle;
}

.minimal-product-card-content {
  margin: 0.5% 3% 0% 2%;
  min-width: 0;
  width:82%;
}

.minimal-product-card-title {
  font-weight: bold;
  margin-top: 0.75rem;
  margin-bottom: 0.5rem;

  & img {
    height: 1.15rem;
    vertical-align: baseline;
  }

  & h5 {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}

.minimal-product-card-cat-info {
  font-size: 0.8rem;
  width:80%;
  overflow: hidden;
  white-space: nowrap;
  display: block;
  text-overflow:ellipsis;
  direction: rtl;
}

.minimal-product-card-price {
  font-stretch: condensed;
  color: $primary;
}

.minimal-product-footer {
  display: flex;
  justify-content: space-between;
  font-size: 0.8rem;
  margin-top: 0.75rem;
  margin-bottom: 0.25rem;
}

@media screen and (max-width: map-get($grid-breakpoints, "sm")) {
  .minimal-product-card-title {
    font-size: 0.8rem;
  }

  .minimal-product-card-price {
    font-size: 1.1rem;
  }

  .minimal-product-footer {
    width:90%;
    margin-bottom: 0;
  }

  .minimal-product-card {
    // height: 100px;
    width: 100%;
  }

  .minimal-product-card-cat-info {
    width:100%;
    font-size: 0.9rem;
  }

  .minimal-product-footer p {
    font-size: 0.8rem;
    margin: 0;
  }

  .minimal-product-card-content {
    margin: 3% 1% 1% 3%;
    background-color: white;
    height: 100%;
    width: 60%;
  }

  .minimal-product-card-image {
    padding: 0;
    max-width: 40%;
  }
}

.category-item-image {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 100%;
}

@media screen and (max-width: map-get($grid-breakpoints, "sm")) {
  .category-item-image {
    background-size: cover;
  }

  .minimal-product-card-container {
    & .minimal-product-band {
      right: 56vw !important;
    }
  }
}

.minimal-product-card-container {
  & .carousel.slide {
    height: 100%;

    & .carousel-inner {
      height: 100%;

      & .carousel-item {
        height: 100%;
        background-color: $gray-200;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publication/CardWideMinimal.vue